import { motion } from "framer-motion";

const TRAILS = [
  {
    d: "M70 335 C160 320 170 240 260 225 C350 210 340 130 430 115 C490 104 525 80 545 60",
    start: [70, 335],
    end: [545, 60],
  },
  {
    d: "M60 90 C150 110 190 190 280 200 C370 210 420 290 540 320",
    start: [60, 90],
    end: [540, 320],
  },
  {
    d: "M80 200 C170 240 250 120 340 160 C430 200 480 250 530 330",
    start: [80, 200],
    end: [530, 330],
  },
  {
    d: "M70 300 C130 180 260 260 330 170 C400 80 470 140 540 80",
    start: [70, 300],
    end: [540, 80],
  },
];

const ELEV = [
  "M0 60 L35 50 L70 55 L105 36 L140 44 L175 22 L210 30 L245 14 L280 20",
  "M0 55 L35 58 L70 40 L105 46 L140 28 L175 36 L210 18 L245 26 L280 12",
  "M0 62 L35 44 L70 50 L105 30 L140 40 L175 18 L210 28 L245 40 L280 16",
  "M0 50 L35 56 L70 36 L105 44 L140 24 L175 32 L210 20 L245 34 L280 10",
];

const PINES = [
  [95, 115],
  [140, 80],
  [505, 300],
  [545, 340],
  [105, 300],
  [460, 60],
];
const TUFTS = [
  [110, 110],
  [180, 300],
  [420, 90],
  [500, 240],
  [250, 70],
];
const FALLING = [
  [120, 90, "#D4A373"],
  [200, 320, "#E07A5F"],
  [380, 70, "#D4A373"],
  [470, 300, "#E07A5F"],
  [520, 150, "#D4A373"],
];

function Pine({ x, y }) {
  return (
    <g transform={`translate(${x},${y})`} opacity="0.8">
      <path d="M0 0 L-7 14 L7 14 Z" fill="#2D6A4F" />
      <path d="M0 -10 L-6 4 L6 4 Z" fill="#367A58" />
    </g>
  );
}

function Tuft({ x, y }) {
  return (
    <g
      transform={`translate(${x},${y})`}
      stroke="#52B788"
      strokeWidth="1.6"
      strokeLinecap="round"
      opacity="0.7"
      fill="none"
    >
      <path d="M0 0 C-2 -6 -5 -8 -6 -10" />
      <path d="M2 0 C2 -7 3 -9 4 -12" />
      <path d="M4 0 C7 -5 8 -7 10 -8" />
    </g>
  );
}

export default function TrailMap({ trailKey = 0, waypoints = [], vibe = "", name = "" }) {
  const trail = TRAILS[trailKey % TRAILS.length];
  const elev = ELEV[trailKey % ELEV.length];
  const wp = waypoints.length
    ? waypoints
    : [
        { label: "Trailhead", x: 12, y: 82 },
        { label: "Midpoint", x: 48, y: 44 },
        { label: "Destination", x: 88, y: 18 },
      ];
  const toXY = (w) => [w.x * 6, w.y * 4];

  return (
    <div
      data-testid="trail-map"
      className="relative mt-8 overflow-hidden rounded-2xl border border-forest-600/60 bg-forest-950"
    >
      <svg viewBox="0 0 600 400" className="block h-auto w-full">
        <defs>
          <radialGradient id="paper" cx="50%" cy="40%" r="80%">
            <stop offset="0%" stopColor="#0E2A1E" />
            <stop offset="100%" stopColor="#071811" />
          </radialGradient>
          <linearGradient id="elevFill" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#52B788" stopOpacity="0.35" />
            <stop offset="100%" stopColor="#52B788" stopOpacity="0.02" />
          </linearGradient>
          <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
            <path d="M40 0 H0 V40" fill="none" stroke="#1C4430" strokeWidth="0.6" opacity="0.5" />
          </pattern>
        </defs>

        <rect width="600" height="400" fill="url(#paper)" />
        <rect width="600" height="400" fill="url(#grid)" />

        <path
          d="M-30 120 C80 90 150 165 270 135 C390 105 460 175 630 135"
          fill="none"
          stroke="#1C4430"
          strokeWidth="1"
          opacity="0.8"
        />
        <path
          d="M-30 160 C90 130 160 205 280 175 C400 145 470 215 630 175"
          fill="none"
          stroke="#1C4430"
          strokeWidth="1"
          opacity="0.5"
        />
        <path
          d="M-30 330 C90 300 180 355 300 330 C420 305 500 350 630 325"
          fill="none"
          stroke="#1C4430"
          strokeWidth="1"
          opacity="0.6"
        />

        {vibe === "Lakeside Views" && (
          <g>
            <path
              d="M30 250 C120 225 210 270 300 250 C390 230 470 270 575 245 L575 300 C430 330 180 330 30 300 Z"
              fill="#0F2E3D"
              opacity="0.9"
            />
            <path
              d="M110 278 q22 -7 44 0 M200 292 q22 -7 44 0 M330 282 q22 -7 44 0"
              stroke="#3D7A8C"
              strokeWidth="1.4"
              fill="none"
              opacity="0.7"
            />
          </g>
        )}
        {vibe === "Open Meadows" && TUFTS.map(([x, y], i) => <Tuft key={i} x={x} y={y} />)}
        {vibe === "Shady Forests" && PINES.map(([x, y], i) => <Pine key={i} x={x} y={y} />)}
        {vibe === "Autumn/Fall Foliage" &&
          FALLING.map(([x, y, c], i) => (
            <circle key={i} cx={x} cy={y} r="3.5" fill={c} opacity="0.65" />
          ))}

        <motion.path
          d={trail.d}
          fill="none"
          stroke="#52B788"
          strokeWidth="9"
          strokeLinecap="round"
          opacity="0.15"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 2, ease: "easeInOut", delay: 0.3 }}
        />
        <motion.path
          data-testid="trail-path"
          d={trail.d}
          fill="none"
          stroke="#52B788"
          strokeWidth="3"
          strokeLinecap="round"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 2.2, ease: "easeInOut", delay: 0.3 }}
        />

        {wp.map((w, i) => {
          const [x, y] = toXY(w);
          const last = i === wp.length - 1;
          return (
            <g key={i} transform={`translate(${x},${y})`}>
              {!last && (
                <motion.circle
                  r="5"
                  fill="none"
                  stroke="#52B788"
                  initial={{ r: 5, opacity: 0.7 }}
                  animate={{ r: 16, opacity: 0 }}
                  transition={{ duration: 2, repeat: Infinity, delay: i * 0.4, ease: "easeOut" }}
                />
              )}
              <circle
                r="5"
                fill={last ? "#D4A373" : "#52B788"}
                stroke="#06140E"
                strokeWidth="1.5"
              />
              <text
                y="-12"
                textAnchor="middle"
                fill="#B0C4B8"
                fontSize="11"
                fontFamily="JetBrains Mono, monospace"
                letterSpacing="1"
              >
                {w.label.toUpperCase()}
              </text>
            </g>
          );
        })}

        <g transform="translate(24, 24)">
          <rect
            width="200"
            height="64"
            rx="8"
            fill="#06140E"
            opacity="0.55"
            stroke="#1C4430"
          />
          <g transform="translate(12, 8)">
            <path
              d={`${elev} L280 52 L0 52 Z`}
              fill="url(#elevFill)"
              stroke="none"
              transform="scale(0.63)"
            />
            <motion.path
              d={elev}
              transform="scale(0.63)"
              fill="none"
              stroke="#52B788"
              strokeWidth="2"
              initial={{ pathLength: 0 }}
              animate={{ pathLength: 1 }}
              transition={{ duration: 1.6, delay: 0.8, ease: "easeInOut" }}
            />
            <text
              x="0"
              y="58"
              fontSize="8"
              fill="#6E917C"
              fontFamily="JetBrains Mono, monospace"
              letterSpacing="2"
            >
              ELEVATION
            </text>
          </g>
        </g>

        <g transform="translate(574, 96)" stroke="#7BAE8E" fill="none">
          <circle r="13" opacity="0.6" />
          <path d="M0 -9 L3 3 L0 0 L-3 3 Z" fill="#D4A373" stroke="none" />
          <text
            y="-20"
            textAnchor="middle"
            fill="#7BAE8E"
            fontSize="9"
            fontFamily="JetBrains Mono, monospace"
            stroke="none"
          >
            N
          </text>
        </g>

        <g transform="translate(30, 378)" stroke="#6E917C">
          <path d="M0 0 H80" strokeWidth="1" />
          <path d="M0 -4 V4 M40 -4 V4 M80 -4 V4" strokeWidth="1" />
          <text
            x="88"
            y="4"
            fill="#6E917C"
            fontSize="9"
            fontFamily="JetBrains Mono, monospace"
            stroke="none"
          >
            0.5 KM
          </text>
        </g>
      </svg>
      <div className="absolute bottom-3 right-4 font-mono text-[10px] uppercase tracking-[0.2em] text-forest-muted">
        Fig. 01 — {name}
      </div>
    </div>
  );
}
